import {configureStore} from "@reduxjs/toolkit"
import {setupListeners} from "@reduxjs/toolkit/query"
import {
    userActions
} from "./actions/user.action"
import {
    settingAction
} from "./actions/setting.action"
import {
    classRoomAction
} from "./actions/classSetup.action"
import {
    admissionAction
} from "./actions/admissionSetup.action"
import {
    uploadContentAction
} from "./actions/upload_content"
import {
    downloadAction
} from "./actions/download.action"
import {
    feeCollectionAction
} from "./actions/feeCollection.action"
import {validatePassAction} from "./actions/validateStudents.action"
import formSlice from "./actions/formValue.action"
import {examAction} from "./actions/examAction"
import { studentAction } from "./actions/studentAction"
import {certificatesAction} from "./actions/certificate.action"
import {
    lectureAction,
    studentLearnAction
} from "./actions/lecture.action"


export const Store = configureStore({
    reducer:{
        [userActions.reducerPath]: userActions.reducer,
        [settingAction.reducerPath] : settingAction.reducer,
        [classRoomAction.reducerPath] : classRoomAction.reducer,
        [admissionAction.reducerPath] : admissionAction.reducer,
        [uploadContentAction.reducerPath] : uploadContentAction.reducer,
        [downloadAction.reducerPath] : downloadAction.reducer,
        [feeCollectionAction.reducerPath] : feeCollectionAction.reducer,
        [validatePassAction.reducerPath] : validatePassAction.reducer,
        [examAction.reducerPath] : examAction.reducer,
        [studentAction.reducerPath] : studentAction.reducer,
        [certificatesAction.reducerPath] : certificatesAction.reducer,
        [lectureAction.reducerPath] : lectureAction.reducer,
        [studentLearnAction.reducerPath] : studentLearnAction.reducer,
        // [formSlice.reducerPath] : formSlice.reducer,

        form:formSlice.reducer
    },
    middleware:(getDefaultMiddleware)=> 
        getDefaultMiddleware().
        concat(settingAction.middleware).
        concat(userActions.middleware).
        concat(classRoomAction.middleware).
        concat(admissionAction.middleware).
        concat(uploadContentAction.middleware).
        concat(downloadAction.middleware).
        concat(feeCollectionAction.middleware).
        concat(validatePassAction.middleware).
        concat(examAction.middleware).
        concat(studentAction.middleware).
        concat(certificatesAction.middleware).
        concat(lectureAction.middleware).
        concat(studentLearnAction.middleware)
})


setupListeners(Store.dispatch)